import * as React from "react";
import "../styles/Loading.css";
import {Spinner, SpinnerSize} from "@fluentui/react";

const Loading = () => {
    return (
        <Spinner
            id={"loader"}
            styles={{circle: {borderWidth: 3, width: 50, height: 50}}}
            size={SpinnerSize.large}
        />
    );
};

export default Loading;
